(function($) {

  // 特定要素クリックで波紋 (ripple.js)
  $(".ripple, button, .button").ripple();

  // apply classes to html if mobile
  var md = new MobileDetect(window.navigator.userAgent);
  var mobile = "mobile " + md.phone() + " " + md.os() + " " + md.userAgent();
  if (md.mobile()) {
    $("html").addClass(mobile.toLowerCase());
  }

  // clickイベントでの処理（mouseenter は省略）
  var clickEventType = ((window.ontouchstart !== null) ? 'click' : 'touchstart');

  // toggle offcanvas
  $("._header__tools__toggle--menu").on(clickEventType, function(e, data) {
    $("body").toggleClass("off-menu");
  });

  // Tocca.jsやめた。スワイプイベントは保留
  // $("._offcanvas").on("swiperight", function(e, data) {
  // 	$("body").removeClass(function(index, className) {
  // 		return (className.match(/\boff-\S+/g) || []).join(" ");
  // 	});
  // });

  // 'off-'で始まるクラスと'active'クラスを削除
  $("._offcanvas__close").on(clickEventType, function(e, data) {
    $('body').removeClass(function(index, className) {
      return (className.match(/\boff-\S+/g) || []).join(' ');
    });
    $('._header__tools__toggle').removeClass('active');
  });

  // offcanvasを開いた状態で画面リサイズした時の対応
  $(window).on('resize', function() {
    if ($(this).width() > 560) {
      console.log('resize');
      $('body').removeClass(function(index, className) {
        return (className.match(/\boff-\S+/g) || []).join(' ');
      });
      $('._header__tools__toggle').removeClass('active');
    }
  }).resize();

  // マイアカウントページのメニューを制御
  $(".woocommerce-MyAccount-content").prepend(
    '<div class="woocommerce-MyAccount-menu"></div>'
  );
  $(".woocommerce-MyAccount-navigation").prepend(
    '<div class="woocommerce-MyAccount-menu-close"></div>'
  );
  $(".woocommerce-MyAccount-menu").on(clickEventType, function() {
    $("body").addClass("account-menu-on");
  });
  $(".woocommerce-MyAccount-menu-close").on(clickEventType, function() {
    $("body").removeClass("account-menu-on");
  });

  // テキストフィールドにフォーカスでラベル飛び出す
  var inputText = $(".input-text");

  inputText.each(function() {
    if ($(this).val().length > 0) {
      $(this).closest(".form-row").addClass("focused");
    }
  });

  inputText
    .focusin(function(e) {
      $(this).closest(".form-row").addClass("focused");
    })
    .focusout(function(e) {
      if ($(this).val() == "") {
        $(this).closest(".form-row").removeClass("focused");
      }
    });

  // レスポンシブテーブル (restables.js)
  function responsiveTables() {
    $(".woocommerce-orders-table,.shop_table.cart").resTables();
  }
  responsiveTables();

  // カート内でajaxに夜商品の削除または数量の更新した際にresTablesを再構築する
  $(document.body).on("updated_cart_totals", function() {
    responsiveTables();
  });

  //都道府県を変更したときに、送料を更新する（請求先）
  function updateShippingFeeOnCheckout() {
    $("#billing_postcode").on("blur", function() {
      $(document.body).trigger("update_checkout");
    });

    $("#billing_state").on("change", function() {
      $(document.body).trigger("update_checkout");
    });

    //都道府県を変更したときに、送料を更新する（お届け先）
    $("#shipping_postcode").on("blur", function() {
      $(document.body).trigger("update_checkout");
    });

    $("#shipping_state").on("blur", function() {
      $(document.body).trigger("update_checkout");
    });
  }
  if ($("body").hasClass("page-checkout")) {
    updateShippingFeeOnCheckout();
  }

  // input（テキスト系）を囲んでいないlabelの場合にクラス付与
  var combileLabel = 'input[type="text"], input[type="email"], input[type="password"], input[type="search"], input[type="tel"], input[type="text"], input[type="url"], textarea';
  $(combileLabel).prev("label").addClass("combine");

  // wrapperがある場合も対応する
  $('.woocommerce-input-wrapper:has(input), .woocommerce-input-wrapper:has(textarea)').prev("label").addClass("combine");

  // ページ読み込み時のチェックボックスの状態を取得
  $('input[type="checkbox"]').parent('label').addClass('checkbox');
  $('input[type="checkbox"]').each(function() {
    if ($(this).prop('checked') == true) {
      $(this).parent('label').addClass('checked');
    } else {
      $(this).parent('label').addClass('not-checked');
    }
  });

  // ページ読み込み時のラジオボタンの状態を取得
  $('input[type="radio"]').parent('label').addClass('radio');
  $('input[type="radio"]').each(function() {
    if ($(this).prop('checked') == true) {
      $(this).parent('label').addClass('checked');
    } else {
      $(this).parent('label').addClass('not-checked');
    }
  });

  // チェックボックス状態の変更を取得
  $('input').change(function() {
    if (this.checked) {
      $(this).parent('label').removeClass('not-checked').addClass('checked');
    }
    if (!this.checked) {
      $(this).parent('label').removeClass('checked').addClass('not-checked');
    }
  })

  // ログインページ
  $('#rememberme').prop('checked', true);
  $('#loginform label[for="user_login"], #loginform label[for="user_pass"]').contents().filter(function() {
    return this.nodeType === 3;
  }).remove();

  $('#loginform input[type="text"]').attr('placeholder', 'ユーザー名');
  $('#loginform input[type="password"]').attr('placeholder', 'パスワード');

  // フォームの入力値を保存
  // 使う場合はfunctions.phpで設定する
  // wp_enqueue_script('garlic', 'https://cdnjs.cloudflare.com/ajax/libs/garlic.js/1.4.1/garlic.min.js', array('jquery'), false, true);
  // $('form').garlic({
  //   onRetrieve: function(elem, retrievedValue) {
  //     console.log(elem, retrievedValue);
  //     $(elem).closest('.form-row').addClass('focused');
  //   }
  // });

})(jQuery);
